import __isEmpty from 'lodash/isEmpty';
import styles from './bondia.module.scss';
import Enllac from 'components/corporatiu/Enllac';
import Icona from 'components/corporatiu/ui/Icona';

export default function BonDia() {
    return (
        <div className={styles.wrapper}>
            <blockquote className={styles.cita}>
                <p>El meu país és aquell on, quan dic “Bon dia”, em responen: “Sí, sembla que fa bon dia”</p>
                <footer>Josep Pla</footer>
            </blockquote>
            <p>
                La CCMA ofereix un servei públic audiovisual compromès amb la promoció, la consolidació i l&apos;expansió de la
                cultura i la llengua catalanes, alhora que en reflecteix la diversitat. Els mitjans de la Corporació, referents en
                l&apos;àmbit territorial de Catalunya, treballen per fomentar un espai comú de comunicació i amb la voluntat de
                reforçar els vincles, mitjançant la cooperació i les activitats que li són pròpies, entre les Balears, el País
                Valencià, la Franja de Ponent, la Catalunya del Nord, Andorra, l&apos;Alguer i Catalunya
            </p>
            <p>
                A través d&apos;aquest espai podeu accedir a una àmplia oferta de continguts audiovisuals dels diferents
                territoris on compartim la mateixa llengua i que són disponibles a la xarxa. Es tracta d&apos;un directori obert.
                Els mitjans de comunicació audiovisual que vulguin formar-ne part poden fer arribar la seva petició a
                3cat.cat/atenció.
            </p>
            <p>
                <strong>Criteris de selecció</strong>
            </p>
            <p>
                Poden formar-ne part mitjans de comunicació audiovisual presents a la xarxa que s&apos;expressin totalment o
                majoritàriament en la nostra llengua, que generin continguts propis d&apos;àudio o vídeo i que actualitzin de
                manera freqüent els seus continguts.
            </p>

            <h2 className={styles.mitjans} id='mitjans'>
                Mitjans audiovisuals segons origen geogràfic
            </h2>

            <ul className={styles.llistaZones}>
                <li className={styles.alguer}>
                    <Enllac href='#alguer'>Alguer</Enllac>
                </li>
                <li className={styles.andorra}>
                    <Enllac href='#andorra'>Andorra</Enllac>
                </li>
                <li className={styles.balears}>
                    <Enllac href='#balears'>Balears</Enllac>
                </li>
                <li className={styles.catalunya}>
                    <Enllac href='#catalunya'>Catalunya</Enllac>
                </li>
                <li className={styles.catalunyaNord}>
                    <Enllac href='#catalunyaNord'>Catalunya Nord</Enllac>
                </li>
                <li className={styles.paisValencia}>
                    <Enllac href='#paisValencia'>País Valencià</Enllac>
                </li>
            </ul>

            {/*<!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  ALGUER   -->*/}
            <div id='alguer' className={styles.zona}>
                <div className={styles.zonaHeading}>
                    <h3>Alguer</h3>
                    <span className={styles.inici}>
                        <Enllac href='#mitjans'>
                            <span>tornar a dalt</span>
                        </Enllac>
                        <Icona className={styles.icona} icona='fletxa_simple_amunt' alt='anar amunt' isBlanc={false} mida={30} />
                    </span>
                </div>
                <ul>
                    <li>
                        <h4>Ràdio</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='http://www.ondastereo.it/' novaFinestra={true}>
                                    <span>Onda Stereo</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Mitjans digitals Audiovisuals</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='http://cat.alguer.it/' novaFinestra={true}>
                                    <span>Alguer.cat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.alguer.it/' novaFinestra={true}>
                                    <span>Alguer.it</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.catalantv.it' novaFinestra={true}>
                                    <span>Catalan Web TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            {/*<!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  ANDORRA   -->*/}
            <div id='andorra' className={styles.zona}>
                <div className={styles.zonaHeading}>
                    <h3>Andorra</h3>
                    <span className={styles.inici}>
                        <Enllac href='#mitjans'>
                            <span>tornar a dalt</span>
                        </Enllac>
                        <Icona className={styles.icona} icona='fletxa_simple_amunt' alt='anar amunt' isBlanc={false} mida={30} />
                    </span>
                </div>
                <ul>
                    <li>
                        <h4>Televisió</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='http://www.andorradifusio.ad/' novaFinestra={true}>
                                    <span>AndorraDifusió / RTVA</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Ràdio</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://www.bisbaturgell.org/index.php/ca/' novaFinestra={true}>
                                    <span>Ràdio Principat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://cadenaser.com/emisora/radio_ser_principat_d_andorra/' novaFinestra={true}>
                                    <span>Ràdio Ser Principat d&apos;Andorra</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiovalira.ad/' novaFinestra={true}>
                                    <span>Ràdio Valira</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.andorradifusio.ad/endirecte/rna' novaFinestra={true}>
                                    <span>Andorra Difusió</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Mitjans digitals Audiovisuals</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='http://www.diariandorra.ad/' novaFinestra={true}>
                                    <span>Diari d&apos;Andorra</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elperiodic.ad/' novaFinestra={true}>
                                    <span>El Periòdic d&apos;Andorra</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ara.ad/' novaFinestra={true}>
                                    <span>Ara Andorra</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.andorradifusio.ad/informatiu' novaFinestra={true}>
                                    <span>Andorra Difusió</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.bondia.ad/' novaFinestra={true}>
                                    <span>Bon Dia</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://forum.ad/' novaFinestra={true}>
                                    <span>Fòrum</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.ana.ad/' novaFinestra={true}>
                                    <span>ANA - Agència de Notícies Andorrana</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            {/*<!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~   BALEARS   -->*/}
            <div id='balears' className={styles.zona}>
                <div className={styles.zonaHeading}>
                    <h3>Illes Balears</h3>
                    <span className={styles.inici}>
                        <Enllac href='#mitjans'>
                            <span>tornar a dalt</span>
                        </Enllac>
                        <Icona className={styles.icona} icona='fletxa_simple_amunt' alt='anar amunt' isBlanc={false} mida={30} />
                    </span>
                </div>
                <ul>
                    <li>
                        <h4>Televisió</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://ib3.org/' novaFinestra={true}>
                                    <span>IB3</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.grup4.com/' novaFinestra={true}>
                                    <span>Canal 4</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtve.es/noticias/illes-balears/' novaFinestra={true}>
                                    <span>RTVE Illes Balears</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://teftv.com/' novaFinestra={true}>
                                    <span>TEF Televisió d&apos;Eivissa i Formentera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Ràdio</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://ib3.org/radio' novaFinestra={true}>
                                    <span>IB3 Ràdio de les Illes Balears</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.onamediterrania.cat/' novaFinestra={true}>
                                    <span>Ona Mediterrània</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.titoieta.cat/index.php' novaFinestra={true}>
                                    <span>Titoieta Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioillaformentera.cat/' novaFinestra={true}>
                                    <span>Ràdio Illa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Mitjans digitals Audiovisuals</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://www.arabalears.cat/' novaFinestra={true}>
                                    <span>Ara Balears</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.dbalears.cat/' novaFinestra={true}>
                                    <span>DBalears</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.esdiari.com/' novaFinestra={true}>
                                    <span>Es diari digital de Menorca</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://menorcaaldia.com/' novaFinestra={true}>
                                    <span>Menorca al dia</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://menorca.portaldetuciudad.com/index_ca-es.html' novaFinestra={true}>
                                    <span>Menorca portal de tu ciudad</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.noudiari.es/' novaFinestra={true}>
                                    <span>Noudiari.es</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            {/*<!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  CATALUNYA   -->*/}

            <div id='catalunya' className={styles.zona}>
                <div className={styles.zonaHeading}>
                    <h3>Catalunya</h3>
                    <span className={styles.inici}>
                        <Enllac href='#mitjans'>
                            <span>tornar a dalt</span>
                        </Enllac>
                        <Icona className={styles.icona} icona='fletxa_simple_amunt' alt='anar amunt' isBlanc={false} mida={30} />
                    </span>
                </div>
                <ul>
                    <li>
                        <h4>Televisió</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://www.25televisio.com/' novaFinestra={true}>
                                    <span>25 Televisió</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/3catinfo/' novaFinestra={true}>
                                    <span>3catinfo.cat</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.8tv.cat/' novaFinestra={true}>
                                    <span>8TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Aran TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.balaguer.tv/' novaFinestra={true}>
                                    <span>Balaguer TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Banyoles TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.fcbarcelona.cat/ca/barca-tv' novaFinestra={true}>
                                    <span>Barça TV</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/user/televisioblanes' novaFinestra={true}>
                                    <span>Blanes TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/bondiatv/' novaFinestra={true}>
                                    <span>Bon dia TV</span>
                                </Enllac>
                                <span>Temàtica: Cultural</span>
                            </li>
                            <li>
                                <Enllac href='https://beteve.cat/' novaFinestra={true}>
                                    <span>BTV - Barcelona TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocalellatv.cat/' novaFinestra={true}>
                                    <span>Calella TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.canal10.cat/' novaFinestra={true}>
                                    <span>Canal 10 Empordà</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.canal21ebre.com/' novaFinestra={true}>
                                    <span>Canal 21</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/3cat/directes/33/' novaFinestra={true}>
                                    <span>Canal 33</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://canalblau.tv/' novaFinestra={true}>
                                    <span>Canal Blau</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Canal Camp</span>
                                </Enllac>
                                <span>Temàtica: Generalista/p&gt;</span>
                            </li>
                            <li>
                                <Enllac href='https://www.canalreustv.cat/' novaFinestra={true}>
                                    <span>Canal Reus TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/channel/UCsDvm-A8K4AJ9F3wTtqWhgA' novaFinestra={true}>
                                    <span>Canal Set</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Canal TE - Terres de l&apos;Ebre</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Canal terrassa Vallès</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/castelldefelstv' novaFinestra={true}>
                                    <span>Castelldefels TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.cugat.cat/tv' novaFinestra={true}>
                                    <span>Cugat TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/channel/UCejG8OgBDtCILd19GrOOwqg' novaFinestra={true}>
                                    <span>Cugat Mèdia TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://ebredigital.cat/' novaFinestra={true}>
                                    <span>Ebre Digital</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://el9nou.cat/el9tv/' novaFinestra={true}>
                                    <span>El 9 TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elprat.digital/tv/' novaFinestra={true}>
                                    <span>El Prat TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Empordà TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/esport3/' novaFinestra={true}>
                                    <span>Esport 3</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://etv.cat/' novaFinestra={true}>
                                    <span>ETV - És TeVa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.gavatv.cat/' novaFinestra={true}>
                                    <span>Gava TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>GI TV - TV de Girona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/graciatelevisio/' novaFinestra={true}>
                                    <span>Gràcia TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/channel/UCAmm5xaLfNeYi381MD_gIpQ' novaFinestra={true}>
                                    <span>La Granada TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Lleida Televisió</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/channel/UCd1Zt1JmoT2pL53ENTjpqWw' novaFinestra={true}>
                                    <span>Lo Pallars TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://martorelltv.com/' novaFinestra={true}>
                                    <span>Martorell TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>M1TV - Maresme</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/channel/UCibNxbq5GcPkgyM1VgwlZmQ' novaFinestra={true}>
                                    <span>Matadepera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://mataroaudiovisual.cat' novaFinestra={true}>
                                    <span>Mataró Tv</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.molatv.cat/' novaFinestra={true}>
                                    <span>Mola TV</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/channel/UC3W_srHzdk8ThgGJZ3cnI-Q' novaFinestra={true}>
                                    <span>Molins TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.olot.tv' novaFinestra={true}>
                                    <span>Olot Televisió</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://pirineustv.cat/' novaFinestra={true}>
                                    <span>Pirineus TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://rtvc.cat/' novaFinestra={true}>
                                    <span>RTV Cardedeu</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtvelvendrell.cat/' novaFinestra={true}>
                                    <span>RTV El Vendrell</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtvvilafranca.cat/' novaFinestra={true}>
                                    <span>RTV Vilafranca</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.santandreutv.com/' novaFinestra={true}>
                                    <span>Sant Andreu TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/tv3/sx3/' novaFinestra={true}>
                                    <span>SX3.cat</span>
                                </Enllac>
                                <span>Temàtica: Infantil</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tac12.tv/' novaFinestra={true}>
                                    <span>TAC 12</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.canaltaronja.cat' novaFinestra={true}>
                                    <span>Canal Taronja</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.canaltaronja.cat/anoia' novaFinestra={true}>
                                    <span>Taronja Digital Anoia</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.canaltaronja.cat/central' novaFinestra={true}>
                                    <span>Taronja Digital Bages</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.canaltaronja.cat/osona' novaFinestra={true}>
                                    <span>Taronja Digital Osona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.bdncom.cat/' novaFinestra={true}>
                                    <span>TeleB - TV de Badalona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://tvgirona.com/' novaFinestra={true}>
                                    <span>Televisió de Girona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://lhdigital.cat/' novaFinestra={true}>
                                    <span>Televisió de l&apos;Hospitalet</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Televisió del Ripollés</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://terrassadigital.cat' novaFinestra={true}>
                                    <span>Terrassa Digital</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                Teveon
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                Tot TV
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>TV Berguedà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>TV Costa Brava</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                TV Manresa
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tvsantcugat.cat/' novaFinestra={true}>
                                    <span>TV Sant Cugat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://tvvandellos.cat/' novaFinestra={true}>
                                    <span>TV Vandellós</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.televisiovilanova.cat/' novaFinestra={true}>
                                    <span>TV Vilanova</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://tv.vilanovadelvalles.cat/' novaFinestra={true}>
                                    <span>Televisió de Vilanova del Vallès (VdV TV)</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtv10.cat/' novaFinestra={true}>
                                    <span>TV10 - Baix Llobregat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/tv3/' novaFinestra={true}>
                                    <span>TV3</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtve.es/television/catalunya/' novaFinestra={true}>
                                    <span>TVE Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>TVR Ripollès</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.youtube.com/playlist?list=PL6h6cYKBvoDpCPLixuEoaXafqEXhhFEp2'
                                    novaFinestra={true}
                                >
                                    Valldecamprodon TV
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Vallès Oriental TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.vallesvisio.cat/' novaFinestra={true}>
                                    <span>Vallès Visió</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.youtube.com/user/AjuntamentVallirana' novaFinestra={true}>
                                    <span>Vallirana TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.viladecanstv.tv/' novaFinestra={true}>
                                    <span>Viladecans TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>VOTV - Vallès Oriental TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Xala!</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>XIP.TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Ràdio</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://www.alcanarradio.cat/' novaFinestra={true}>
                                    <span>Alcanar Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.alcover.cat/index.php?option=com_content&amp;view=article&amp;id=192&amp;Itemid=191'
                                    novaFinestra={true}
                                >
                                    Alcover Ràdio
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.alpicatradio.com' novaFinestra={true}>
                                    <span>Alpicat Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                Altafulla Ràdio
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radio.amposta.cat/' novaFinestra={true}>
                                    <span>Amposta Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.antenaaldaia.com/' novaFinestra={true}>
                                    <span>Antena Al Dia</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://antenacaro.cat/' novaFinestra={true}>
                                    <span>Antena Caro</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://basradioweb.wordpress.com' novaFinestra={true}>
                                    <span>Bas Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://bellvei.cat/bellvei-radio/' novaFinestra={true}>
                                    <span>Bellvei Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                Boca Ràdio
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://beteve.cat/en-directe/radio/' novaFinestra={true}>
                                    <span>BTV Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://calafell.tv/' novaFinestra={true}>
                                    <span>Calafell Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://caldesdemalavella.cat/index.php/ca/historico-noticias/3595-escolta-caldesfm-online'
                                    novaFinestra={true}
                                >
                                    Caldes FM
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://camradio.blogspot.com/' novaFinestra={true}>
                                    <span>Cam Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='http://www.olerdola.cat/serveis-municipals/mitjans-informacio-municipal/canal-20'
                                    novaFinestra={true}
                                >
                                    Canal 20 Ràdio Olèrdola
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://podcast.canalblau.cat/' novaFinestra={true}>
                                    <span>Canal Blau FM</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/catradio/catalunya-musica/' novaFinestra={true}>
                                    <span>Catalunya Música</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/catradio/' novaFinestra={true}>
                                    <span>Catalunya Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.radiovila-sacra.cat/' novaFinestra={true}>
                                    <span>Cent-7 Música</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.cerdanyola.info/cerdanyola-radio' novaFinestra={true}>
                                    <span>Cerdanyola Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.constantiradio.cat/' novaFinestra={true}>
                                    <span>Constantí Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.cope.es/emisoras/cataluna/barcelona-provincia/barcelona'
                                    novaFinestra={true}
                                >
                                    <span>COPE Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.cugat.cat/radio' novaFinestra={true}>
                                    <span>Cugat.cat Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://el9nou.cat/el9fm/' novaFinestra={true}>
                                    <span>El 9 FM</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elprat.digital/radio/' novaFinestra={true}>
                                    <span>El Prat Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.emunfmradio.cat/' novaFinestra={true}>
                                    <span>Emun FM Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.efmr.cat/' novaFinestra={true}>
                                    <span>Espluga FM Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.flaixfm.cat/' novaFinestra={true}>
                                    <span>Flaix FM</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.girona.cat/gironafm/directe/index.php' novaFinestra={true}>
                                    <span>Girona FM</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://gum.cat' novaFinestra={true}>
                                    <span>Gum FM</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/catradio/icat/' novaFinestra={true}>
                                    <span>icat.cat</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://www.imaginaradio.cat/' novaFinestra={true}>
                                    <span>Imagina Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.lacalartv.cat/directe/' novaFinestra={true}>
                                    <span>La Cala Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.lanovaradio.cat/' novaFinestra={true}>
                                    <span>La Nova Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.laplanaradio.cat' novaFinestra={true}>
                                    <span>La Plana Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laseniaradio.cat/' novaFinestra={true}>
                                    <span>La Sènia Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.santjoandelesabadesses.cat/index.php/noticies-la-veu'
                                    novaFinestra={true}
                                >
                                    <span>La Veu</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.navas.cat/ajuntament/ajuntament/comunicacio/la-veu-de-navas/'
                                    novaFinestra={true}
                                >
                                    La Veu de Navàs
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                Live FM
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.llagosteraradio.cat/' novaFinestra={true}>
                                    <span>Llagostera Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.matadeperaradio.cat' novaFinestra={true}>
                                    <span>Matadepera Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tvmataro.cat/' novaFinestra={true}>
                                    <span>Mataró Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomolinsderei.cat/' novaFinestra={true}>
                                    <span>Molins de Rei Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.montcadaradio.com/' novaFinestra={true}>
                                    <span>Montcada Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.montbui.cat/el-municipi/guia-del-municipi/equipaments/montbui-radio.html'
                                    novaFinestra={true}
                                >
                                    Montbui Ràdio
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://abadiamontserrat.cat/montserrat-radio/' novaFinestra={true}>
                                    <span>Montserrat Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://terrassadigital.cat/radio/' novaFinestra={true}>
                                    <span>NouCinc.2 Ràdio Terrassa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.novaradiolloret.org' novaFinestra={true}>
                                    <span>Nova Ràdio Lloret</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.olesaradio.cat/' novaFinestra={true}>
                                    <span>Olesa Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.onabitlles.cat' novaFinestra={true}>
                                    <span>OnaBitlles</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://onacodinenca.cat/' novaFinestra={true}>
                                    <span>Ona Codinenca</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.antiga.onadesants.cat/' novaFinestra={true}>
                                    <span>Ona de Sants-Montjuïc</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ona-latorre.cat/' novaFinestra={true}>
                                    <span>Ona La Torre</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.onamalgrat.cat/' novaFinestra={true}>
                                    <span>Ona Malgrat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/onavilamalla' novaFinestra={true}>
                                    <span>Ona Vilamalla</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ondacero.es/emisoras/catalunya/' novaFinestra={true}>
                                    <span>ONDA Cero Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ondacero.es/emisoras/catalunya/lleida/' novaFinestra={true}>
                                    <span>Onda cero Lleida</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ondacero.es/emisoras/catalunya/tarragona/' novaFinestra={true}>
                                    <span>Onda Cero Tarragona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosantceloni.cat/' novaFinestra={true}>
                                    <span>Punt 7 Ràdio Sant Celoni</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rac1.cat/' novaFinestra={true}>
                                    <span>RAC 1</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rac105.cat/' novaFinestra={true}>
                                    <span>RAC 105</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://radio010.cat' novaFinestra={true}>
                                    <span>Ràdio 010</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtve.es/radio/radio4/' novaFinestra={true}>
                                    <span>Ràdio 4</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioabrera.cat/' novaFinestra={true}>
                                    <span>Ràdio Abrera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.baqueira.es/ca/radio-aran-baqueira/' novaFinestra={true}>
                                    <span>Ràdio Aran</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://tunein.com/radio/Radio-Arbeca-1078-s111970/' novaFinestra={true}>
                                    <span>Ràdio Arbeca</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.radiobaixpenedes.com/' novaFinestra={true}>
                                    <span>Ràdio Arboç</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.arbucies.cat/ca/arees-i-regidories/comunicacio/radio-arbucies.html'
                                    novaFinestra={true}
                                >
                                    Ràdio Arbúcies
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioarenys.cat' novaFinestra={true}>
                                    <span>Ràdio Arenys</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioarenysmunt.cat' novaFinestra={true}>
                                    <span>Ràdio Arenys de Munt</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://argentona.cat/la_radio' novaFinestra={true}>
                                    <span>Ràdio Argentona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/artesaradio/' novaFinestra={true}>
                                    <span>Ràdio Artesa de Segre</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.radiobalaguer.cat/portal/' novaFinestra={true}>
                                    <span>Ràdio Balaguer</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiobalsareny.org/' novaFinestra={true}>
                                    <span>Ràdio Balsareny</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                Ràdio Banyeres
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiobanyoles.cat/' novaFinestra={true}>
                                    <span>Ràdio Banyoles</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiobarbera.cat/' novaFinestra={true}>
                                    <span>Ràdio Barberà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://cadenaser.com/emisora/radio_barcelona/' novaFinestra={true}>
                                    <span>Ràdio Barcelona - SER Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiobegur.cat/' novaFinestra={true}>
                                    <span>Ràdio Begur</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.facebook.com/Ràdio-Bellpuig-1073-FM-498028833544136/'
                                    novaFinestra={true}
                                >
                                    <span>Ràdio Bellpuig</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.aquibergueda.cat/radioberga/directe/' novaFinestra={true}>
                                    <span>Ràdio Berga</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/radiobesalu/' novaFinestra={true}>
                                    <span>Ràdio Besalú</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioblanes.cat' novaFinestra={true}>
                                    <span>Ràdio Blanes</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiobonmati.cat/' novaFinestra={true}>
                                    <span>Ràdio Bonmatí</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://ventdelnord.tv/graella/nova_radio_cabanes' novaFinestra={true}>
                                    <span>Ràdio Cabanes</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://audiovisualcabrera.net/' novaFinestra={true}>
                                    <span>Ràdio Cabrera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocaldes.cat/' novaFinestra={true}>
                                    <span>Ràdio Caldes</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocalellatv.cat/' novaFinestra={true}>
                                    <span>Radio Calella</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocanet.cat' novaFinestra={true}>
                                    <span>Ràdio Canet</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiocapdecreus.radio12345.com/' novaFinestra={true}>
                                    <span>Ràdio Cap de Creus</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiocapellades.cat/' novaFinestra={true}>
                                    <span>Ràdio Capellades</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://rtvc.cat/' novaFinestra={true}>
                                    <span>Ràdio Cardedeu</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocassa.cat' novaFinestra={true}>
                                    <span>Ràdio Cassà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://radiocastellar.cat/' novaFinestra={true}>
                                    <span>Ràdio Castellar</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocastelldefels.org/' novaFinestra={true}>
                                    <span>Ràdio Castelldefels</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radio.celra.cat/' novaFinestra={true}>
                                    <span>Ràdio Celrà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.cervello.cat/actualitat/radio-cervello/' novaFinestra={true}>
                                    <span>Ràdio Cervelló</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radio.bdncom.cat/' novaFinestra={true}>
                                    <span>Ràdio Ciutat de Badalona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://rctgn.cat' novaFinestra={true}>
                                    <span>Ràdio Ciutat de Tarragona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiociutatvella.es/page2.html' novaFinestra={true}>
                                    <span>Ràdio Ciutat Vella</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocorbera.cat/' novaFinestra={true}>
                                    <span>Ràdio Corbera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocornella.cat/' novaFinestra={true}>
                                    <span>Ràdio Cornellà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiocubelles.cat/' novaFinestra={true}>
                                    <span>Ràdio Cubelles</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiocunit.cat/' novaFinestra={true}>
                                    <span>Ràdio Cunit</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://deltacat.cat/radio-delta/' novaFinestra={true}>
                                    <span>Ràdio Delta</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiodespi.net/' novaFinestra={true}>
                                    <span>Ràdio Despí</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiodesvern.com/' novaFinestra={true}>
                                    <span>Ràdio Desvern</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiodos84.wordpress.com/' novaFinestra={true}>
                                    <span>Ràdio Dos 84</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtvelvendrell.cat/directes/radio/' novaFinestra={true}>
                                    <span>Ràdio El Vendrell</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioesparreguera.cat/' novaFinestra={true}>
                                    <span>Ràdio Esparreguera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioestel.cat/' novaFinestra={true}>
                                    <span>Radio Estel</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiofalset.cat/' novaFinestra={true}>
                                    <span>Ràdio Falset</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.flaixbac.cat/' novaFinestra={true}>
                                    <span>Ràdio Flaixbac</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioflix.cat' novaFinestra={true}>
                                    <span>Ràdio Flix</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.gandesa.cat/radio-gandesa/' novaFinestra={true}>
                                    <span>Ràdio Gandesa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiogava.cat/' novaFinestra={true}>
                                    <span>Ràdio Gavà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiogelida.cat/' novaFinestra={true}>
                                    <span>Ràdio Gelida</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://cadenaser.com/radio-girona/' novaFinestra={true}>
                                    <span>Ràdio Girona - SER Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://laxarxames.cat/' novaFinestra={true}>
                                    <span>Ràdio Granollers</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radioigualada.cat/' novaFinestra={true}>
                                    <span>Ràdio Igualada</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiojoventut.es/' novaFinestra={true}>
                                    <span>Ràdio Joventut</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.juneda.cat/viu/radio-juneda/' novaFinestra={true}>
                                    <span>Ràdio Juneda</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radio.labisbal.cat/' novaFinestra={true}>
                                    <span>Ràdio La Bisbal</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiolallagosta.cat' novaFinestra={true}>
                                    <span>Ràdio La Llagosta</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiolaselva.cat' novaFinestra={true}>
                                    <span>Ràdio La Selva</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiolavall.com/' novaFinestra={true}>
                                    <span>Ràdio La Vall</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.radiobaixpenedes.com/' novaFinestra={true}>
                                    <span>Ràdio L&apos;Arboç</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://torismeles.com/radio-lesradio-lesradio-lesrdio-lesrdio-les/'
                                    novaFinestra={true}
                                >
                                    <span>Ràdio Les</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiolesborges.cat/' novaFinestra={true}>
                                    <span>Ràdio Les Borges</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiolesplanes.com/' novaFinestra={true}>
                                    <span>Ràdio Les Planes</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiollanca.cat/' novaFinestra={true}>
                                    <span>Ràdio Llançà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiollavaneres.cat' novaFinestra={true}>
                                    <span>Ràdio Llavaneres</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiolescala.cat/' novaFinestra={true}>
                                    <span>Ràdio l&apos;Escala</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiohospitalet.cat/' novaFinestra={true}>
                                    <span>Ràdio L&apos;Hospitalet de l&apos;Infant</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiolitoral.com/ca/' novaFinestra={true}>
                                    <span>Ràdio Litoral</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://cadenaser.com/emisora/radio_lleida/' novaFinestra={true}>
                                    <span>Ràdio Lleida - SER Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomanlleu.cat/noticies/llista' novaFinestra={true}>
                                    <span>Ràdio Manlleu</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomanresa.cat' novaFinestra={true}>
                                    <span>Radio Manresa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomarcabarcelona.com/' novaFinestra={true}>
                                    <span>Radio Marca Barcelona</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomaricel.cat/' novaFinestra={true}>
                                    <span>Ràdio Maricel</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://marina360.cat/' novaFinestra={true}>
                                    <span>Ràdio Marina</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://martorelldigital.cat/radio/programes/' novaFinestra={true}>
                                    <span>Ràdio Martorell</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomasquefa.com/' novaFinestra={true}>
                                    <span>Ràdio Masquefa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://radiomoia.cat' novaFinestra={true}>
                                    <span>Ràdio Moià</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomolinsderei.cat' novaFinestra={true}>
                                    <span>Ràdio Molins de Rei</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomollet.com/' novaFinestra={true}>
                                    <span>Ràdio Mollet</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomontblanc.cat/' novaFinestra={true}>
                                    <span>Ràdio Montblanc</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.montesquiu.cat/el-municipi/guia-del-municipi/equipaments/radio-montesquiu.html'
                                    novaFinestra={true}
                                >
                                    Ràdio Montesquiu
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.torroella-estartit.cat/ca/radio-montgri.html' novaFinestra={true}>
                                    <span>Ràdio Montgrí</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radio.montornes.cat/' novaFinestra={true}>
                                    <span>Ràdio Montornès</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/radiomln/' novaFinestra={true}>
                                    <span>Ràdio Mora la Nova</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiomorell.cat/' novaFinestra={true}>
                                    <span>Ràdio Morell</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radio.vallromanes.cat/radios/' novaFinestra={true}>
                                    <span>Ràdio Municipal Vallromanes</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.vilanovainformacio.cat/radio-nova-a-la-carta/' novaFinestra={true}>
                                    <span>Ràdio Nova</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiolot.cat/' novaFinestra={true}>
                                    <span>Ràdio Olot</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioona.cat/' novaFinestra={true}>
                                    <span>Ràdio Ona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiopalafolls.cat/' novaFinestra={true}>
                                    <span>Ràdio Palafolls</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiopalafrugell.cat/' novaFinestra={true}>
                                    <span>Ràdio Palafrugell</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.palamoscomunicacio.cat/web/' novaFinestra={true}>
                                    <span>Ràdio Palamós</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiopalau.cat/' novaFinestra={true}>
                                    <span>Ràdio Palau</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiopiera.online/' novaFinestra={true}>
                                    <span>Ràdio Piera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiopineda.cat/' novaFinestra={true}>
                                    <span>Ràdio Pineda</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.centrecat.com/radiopinos.htm' novaFinestra={true}>
                                    <span>Ràdio Pinós</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiopista.cat/' novaFinestra={true}>
                                    <span>Ràdio Pista</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.rpa.cat/' novaFinestra={true}>
                                    <span>Ràdio Platja d&apos;Aro</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://m.facebook.com/radioponent/' novaFinestra={true}>
                                    <span>Ràdio Ponent</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://premiamedia.cat/' novaFinestra={true}>
                                    <span>Ràdio Premià de Mar</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiopuig-reig.net/' novaFinestra={true}>
                                    <span>Ràdio Puig-Reig</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://radiopuigcerda.cat/' novaFinestra={true}>
                                    <span>Ràdio Puigcerdà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/Iquartfm/' novaFinestra={true}>
                                    <span>Ràdio Quart</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiorapita.cat/' novaFinestra={true}>
                                    <span>Ràdio Ràpita</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://cadenaser.com/emisora/radio_reus/' novaFinestra={true}>
                                    <span>Ràdio Reus - SER Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://corisacat.cat/radio-ripoll-3/' novaFinestra={true}>
                                    <span>Ràdio Ripoll</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ripolletradio.cat' novaFinestra={true}>
                                    <span>Ràdio Ripollet</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioroda.cat/' novaFinestra={true}>
                                    <span>Ràdio Roda</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.rossello.cat/guia/guia/serveis/radio-rossello' novaFinestra={true}>
                                    <span>Ràdio Roselló</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiorubi.cat/' novaFinestra={true}>
                                    <span>Ràdio Rubí</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiosabadell.fm/' novaFinestra={true}>
                                    <span>Ràdio Sabadell</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://mixlr.com/radiosallent/' novaFinestra={true}>
                                    <span>Ràdio Sallent</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.infosalt.cat/radio-salt/' novaFinestra={true}>
                                    <span>Ràdio Salt</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosantandreu.com/' novaFinestra={true}>
                                    <span>Ràdio Sant Andreu</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosantboi.cat/' novaFinestra={true}>
                                    <span>Ràdio Sant Boi</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://m.facebook.com/radiosantcebria?locale=es_ES' novaFinestra={true}>
                                    <span>Ràdio Sant Cebrià</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.cugat.cat/radio' novaFinestra={true}>
                                    <span>Ràdio Sant Cugat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtv10.cat/' novaFinestra={true}>
                                    <span>Ràdio Sant Esteve</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rsf.fm/' novaFinestra={true}>
                                    <span>Ràdio Sant Feliu</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiosantfruitos.cat/WEB/' novaFinestra={true}>
                                    <span>Ràdio Sant Fruitós</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radio.santgregori.cat/' novaFinestra={true}>
                                    <span>Ràdio Sant Gregori</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://web.radiosanthilari.com/' novaFinestra={true}>
                                    <span>Ràdio Sant Hilari</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rsj.cat/' novaFinestra={true}>
                                    <span>Ràdio Sant Joan</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiospsp.com/' novaFinestra={true}>
                                    <span>Ràdio Sant Pere i Sant Pau</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.santpol.cat/ambit.php?id=19' novaFinestra={true}>
                                    <span>Ràdio Sant Pol</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosantquirze.cat/' novaFinestra={true}>
                                    <span>Ràdio Sant Quirze</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiosantsadurni.wordpress.com/' novaFinestra={true}>
                                    <span>Ràdio Sant Sadurní</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.xtrafm.cat/' novaFinestra={true}>
                                    <span>Ràdio Santa Cristina</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.staperpetua.org/radio/index.php' novaFinestra={true}>
                                    <span>Ràdio Santa Perpètua</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.stasusanna.cat/actualitat/radio-santa-susanna' novaFinestra={true}>
                                    <span>Ràdio Santa Susanna</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://santpedor.net/radio/' novaFinestra={true}>
                                    <span>Ràdio Santpedor</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosantvi.cat/' novaFinestra={true}>
                                    <span>Ràdio Santvi</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://rsarria.blogspot.com/' novaFinestra={true}>
                                    <span>Ràdio Sarrià</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radioseu.cat/' novaFinestra={true}>
                                    <span>Ràdio Seu FM</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosilenci.cat' novaFinestra={true}>
                                    <span>Ràdio Silenci</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosio.cat/' novaFinestra={true}>
                                    <span>Ràdio Sió Agramunt</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosuria.cat/' novaFinestra={true}>
                                    <span>Ràdio Súria</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.taradell.cat/radio-taradell-107-7.html' novaFinestra={true}>
                                    <span>Ràdio Taradell</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiotarrega.cat/' novaFinestra={true}>
                                    <span>Ràdio Tàrrega</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.lalocaltiana.cat' novaFinestra={true}>
                                    <span>Ràdio Tiana</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiotordera.cat/radio/' novaFinestra={true}>
                                    <span>Ràdio Tordera</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiotortosa.cat' novaFinestra={true}>
                                    <span>Ràdio Tortosa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/RadioTossa/' novaFinestra={true}>
                                    <span>Ràdio Tossa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radio.es/s/trinitatvella' novaFinestra={true}>
                                    <span>Ràdio Trinitat Vella</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.uradio.cat/' novaFinestra={true}>
                                    <span>Ràdio Ulldecona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.santiscle.cat/municipi/guia-del-municipi/equipaments/radio-vallalta-1075.html'
                                    novaFinestra={true}
                                >
                                    Ràdio Vallalta
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://hit103.cat/' novaFinestra={true}>
                                    <span>Ràdio Valls</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiovila.cat/' novaFinestra={true}>
                                    <span>Ràdio Vila</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiovilablareix.cat/' novaFinestra={true}>
                                    <span>Ràdio Vilablareix</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiovilafant.net/' novaFinestra={true}>
                                    <span>Ràdio Vilafant</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rtvvilafranca.cat/' novaFinestra={true}>
                                    <span>Ràdio Vilafranca</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                Ràdio Vilamajor
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.radiovila-sacra.cat/' novaFinestra={true}>
                                    <span>Ràdio Vilasacra</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://radiovitamenia.wordpress.com/' novaFinestra={true}>
                                    <span>Ràdio Vitamènia</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiovoltrega.com/' novaFinestra={true}>
                                    <span>Ràdio Voltregà</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rap107.fm/' novaFinestra={true}>
                                    <span>RAP 107</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ripolletradio.cat/' novaFinestra={true}>
                                    <span>Ripollet Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.sants3radio.cat/noticies.php' novaFinestra={true}>
                                    <span>Sants 3 Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.santmartisarroca.cat/sarrocaradio/' novaFinestra={true}>
                                    <span>Sarroca Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://cadenaser.com/emisora/ser_tarragona/' novaFinestra={true}>
                                    <span>SER Tarragona</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://solsonafm.media/' novaFinestra={true}>
                                    <span>Solsona FM</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiosvh.info/' novaFinestra={true}>
                                    <span>Ràdio Sant Vicenç dels Horts</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rodadeberaradio.cat/' novaFinestra={true}>
                                    <span>Roda de Berà Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tarragonaradio.cat/' novaFinestra={true}>
                                    <span>Tarragona Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tivissa.cat/tivissa-radio/' novaFinestra={true}>
                                    <span>Tivissa Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ua1.cat/' novaFinestra={true}>
                                    <span>UA1 LLeida Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac
                                    href='https://www.vacarisses.cat/comunicacio/mitjans-municipals/vacarisses-radio.htm'
                                    novaFinestra={true}
                                >
                                    Vacarisses Ràdio
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.vallfogona.net/vallfogona-radio/' novaFinestra={true}>
                                    <span>Vallfogona Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://vilassarradio.cat/' novaFinestra={true}>
                                    <span>Vilassar Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.radiovilassardedalt.cat/' novaFinestra={true}>
                                    <span>Vilassar de Dalt Ràdio</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Mitjans digitals Audiovisuals</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://www.facebook.com/772cat/?locale=ca_ES' novaFinestra={true}>
                                    <span>772.cat</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.acn.cat/' novaFinestra={true}>
                                    <span>ACN - Agència Catalana de Notícies</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                Actualitat Penal
                                <span>Temàtica: Penalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.aguaita.cat/' novaFinestra={true}>
                                    <span>Aguaita</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.alcaldes.eu/' novaFinestra={true}>
                                    <span>Alcaldes</span>
                                </Enllac>
                                <span>Temàtica: Municipal</span>
                            </li>
                            <li>
                                <Enllac href='https://martorell.atotarreu.cat/' novaFinestra={true}>
                                    <span>aMartorell</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.andreuenc.cat' novaFinestra={true}>
                                    <span>Andreuenc</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://anoiadiari.cat' novaFinestra={true}>
                                    <span>Anoia Directe</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ara.cat' novaFinestra={true}>
                                    <span>Ara</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ara.cat/videos/' novaFinestra={true}>
                                    <span>Ara TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://areavisual.cat' novaFinestra={true}>
                                    <span>Àrea Visual</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://www.balaguer.tv/' novaFinestra={true}>
                                    <span>Balaguer Televisió</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://bdndigital.cat/' novaFinestra={true}>
                                    <span>BDNDigital</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.campdesports.cat/' novaFinestra={true}>
                                    <span>Camp d&apos;Esports</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://www.capgros.com' novaFinestra={true}>
                                    <span>Capgròs</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://carrerlliure.cat' novaFinestra={true}>
                                    <span>Carrer Lliure</span>
                                </Enllac>
                                <span>Temàtica: Atletisme</span>
                            </li>
                            <li>
                                <Enllac href='https://catalunyamagrada.cat' novaFinestra={true}>
                                    <span>Catalunya m&apos;agrada</span>
                                </Enllac>
                                <span>Temàtica: Turisme</span>
                            </li>
                            <li>
                                <Enllac href='https://catalunyaplural.cat/ca/' novaFinestra={true}>
                                    <span>Catalunya Plural</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.catalunyapress.cat' novaFinestra={true}>
                                    <span>Catalunya Press</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.catalunyareligio.cat' novaFinestra={true}>
                                    <span>Catalunya religió</span>
                                </Enllac>
                                <span>Temàtica: Religiosa</span>
                            </li>
                            <li>
                                <Enllac href='https://www.catorze.cat/' novaFinestra={true}>
                                    <span>Catorze</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tvcostabrava.com/' novaFinestra={true}>
                                    <span>Costa Brava Digital</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                Diacrític
                                <span>Temàtica: Opinió</span>
                            </li>
                            <li>
                                <Enllac href='https://www.diaridebadalona.com' novaFinestra={true}>
                                    <span>Diari de Badalona</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.diaridegirona.cat/' novaFinestra={true}>
                                    <span>Diari de Girona</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.diaridesabadell.com/' novaFinestra={true}>
                                    <span>Diari de Sabadell</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.diarideterrassa.com/' novaFinestra={true}>
                                    <span>Diari de Terrassa</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://diarieljardi.cat/' novaFinestra={true}>
                                    <span>Diari el Jardí</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.diarimes.com' novaFinestra={true}>
                                    <span>Diari Més</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://diarisanitat.cat/' novaFinestra={true}>
                                    <span>Diari Sanitat</span>
                                </Enllac>
                                <span>Temàtica: Sanitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.ebreactiu.cat' novaFinestra={true}>
                                    <span>Ebre Actiu</span>
                                </Enllac>
                                <span>Temàtica: Natura</span>
                            </li>
                            <li>
                                <Enllac href='https://ebredigital.cat' novaFinestra={true}>
                                    <span>Ebre digital</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.eixdiari.cat/' novaFinestra={true}>
                                    <span>Eix Diari</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elbaix.cat/' novaFinestra={true}>
                                    <span>El baix</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://elcargol.com/' novaFinestra={true}>
                                    <span>El cargol</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elcritic.cat/' novaFinestra={true}>
                                    <span>El crític</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://elcugatenc.cat/' novaFinestra={true}>
                                    <span>El cugatenc</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://elculturista.cat/' novaFinestra={true}>
                                    <span>El culturista</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://diarieducacio.cat/' novaFinestra={true}>
                                    <span>El diari de l&apos;educació</span>
                                </Enllac>
                                <span>Temàtica: Educació</span>
                            </li>
                            <li>
                                <Enllac href='https://diaritreball.cat/' novaFinestra={true}>
                                    <span>El diari del treball</span>
                                </Enllac>
                                <span>Temàtica: Ocupació</span>
                            </li>
                            <li>
                                <Enllac href='https://www.gerio.cat' novaFinestra={true}>
                                    <span>El Gerió</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elgourmetcatala.cat/' novaFinestra={true}>
                                    <span>El gourmet català</span>
                                </Enllac>
                                <span>Temàtica: Gastronomia</span>
                            </li>
                            <li>
                                <Enllac href='https://elwebdelmirall.net/' novaFinestra={true}>
                                    <span>El mirall</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elmon.cat/' novaFinestra={true}>
                                    <span>El Món</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://el9nou.cat/el9tv/' novaFinestra={true}>
                                    <span>El 9 TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://eldigitaldegirona.com/' novaFinestra={true}>
                                    <span>El digital de Girona</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elpuntavui.cat/barcelona.html' novaFinestra={true}>
                                    <span>El Punt Avui TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elperiodico.cat/ca/videos/informatiu/' novaFinestra={true}>
                                    <span>El Periódico</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elsingulardigital.cat/' novaFinestra={true}>
                                    <span>El Singular Digital</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elter.net/' novaFinestra={true}>
                                    <span>El Ter</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.eltotbadalona.cat/' novaFinestra={true}>
                                    <span>El tot Badalona</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.emporda.info' novaFinestra={true}>
                                    <span>Empordà</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://e-noticies.cat/' novaFinestra={true}>
                                    <span>e-Noticies</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.esportandreuenc.cat/' novaFinestra={true}>
                                    <span>Esport Andreuenc</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://www.esportsradio.cat/news' novaFinestra={true}>
                                    <span>Esports ràdio</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://etselquemenges.cat/' novaFinestra={true}>
                                    <span>Ets el que menges</span>
                                </Enllac>
                                <span>Temàtica: Gatronomia</span>
                            </li>
                            <li>
                                <Enllac href='https://www.festadirecte.cat/' novaFinestra={true}>
                                    <span>Fésta</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://www.festacatalunya.cat/' novaFinestra={true}>
                                    <span>Festa Catalunya</span>
                                </Enllac>
                                <span>Temàtica: Festes</span>
                            </li>
                            <li>
                                <Enllac href='https://fosbury.cat/' novaFinestra={true}>
                                    <span>Fosbury</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://www.independent.cat/' novaFinestra={true}>
                                    <span>Independent</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.indicadordeeconomia.com' novaFinestra={true}>
                                    <span>Indicador d&apos;Economia</span>
                                </Enllac>
                                <span>Temàtica: Economia</span>
                            </li>
                            <li>
                                <Enllac href='https://infoanoia.cat/' novaFinestra={true}>
                                    <span>InfoAnoia</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://infocamp.cat' novaFinestra={true}>
                                    <span>Info Camp de Tarragona</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.isabadell.cat/' novaFinestra={true}>
                                    <span>Isabadell</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.jornal.cat/' novaFinestra={true}>
                                    <span>Jornal</span>
                                </Enllac>
                                <span>Temàtica: Economia</span>
                            </li>
                            <li>
                                <Enllac href='https://www.expresdesantandreu.cat/' novaFinestra={true}>
                                    <span>L&apos;Express de Sant Andreu</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.pirineustv.cat/' novaFinestra={true}>
                                    <span>La Cerdanya TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://laciutat.cat/' novaFinestra={true}>
                                    <span>La ciutat</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://laclau.cat/' novaFinestra={true}>
                                    <span>La clau</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.laconca51.cat/' novaFinestra={true}>
                                    <span>La Conca 51</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://filmtopia.net/' novaFinestra={true}>
                                    <span>Filmtopia</span>
                                </Enllac>
                                <span>Temàtica: Cultura, Cinema</span>
                            </li>
                            <li>
                                <Enllac href='https://lafurapenedes.cat/' novaFinestra={true}>
                                    <span>La fura Penedés</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.laguiadereus.com' novaFinestra={true}>
                                    <span>La guia de Reus</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://lamanyana.cat' novaFinestra={true}>
                                    <span>La Mañana</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://lamarina.cat/' novaFinestra={true}>
                                    <span>La marina</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.lamira.cat' novaFinestra={true}>
                                    <span>La Mira</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://www.lapremsadelbaix.es/' novaFinestra={true}>
                                    <span>La Premsa del baix</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.larepublica.cat/' novaFinestra={true}>
                                    <span>La República</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.larepublicaesportiva.cat' novaFinestra={true}>
                                    <span>La República esportiva</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://laselva360.cat' novaFinestra={true}>
                                    <span>La Selva 360</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://veuanoia.cat/' novaFinestra={true}>
                                    <span>La Veu de l&apos;Anoia</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.laxarxa.cat/' novaFinestra={true}>
                                    <span>La Xarxa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://lhdigital.cat/web/digital-h/' novaFinestra={true}>
                                    <span>L&apos;H Digital</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.independentbarbera.cat/' novaFinestra={true}>
                                    <span>L&apos;independent de Barberà</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://lleidadiari.cat' novaFinestra={true}>
                                    <span>Lleida Diari</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://liniaxarxa.cat/liniacornella/' novaFinestra={true}>
                                    <span>Línia Cornellà</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://liniaxarxa.cat/linialh/' novaFinestra={true}>
                                    <span>Línia l&apos;Hospitalet</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.loest.cat' novaFinestra={true}>
                                    <span>L&apos;Oest</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://ludica.cat/' novaFinestra={true}>
                                    <span>Lúdica</span>
                                </Enllac>
                                <span>Temàtica: Video jocs</span>
                            </li>
                            <li>
                                <Enllac href='https://www.manresadiari.cat/' novaFinestra={true}>
                                    <span>Manresa diari</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://marina360.cat/' novaFinestra={true}>
                                    <span>Maresme360</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.marfanta.com' novaFinestra={true}>
                                    <span>Marfanta</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://martorelltv.com/' novaFinestra={true}>
                                    <span>Martorell TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.media.cat/' novaFinestra={true}>
                                    <span>Mèdia.cat</span>
                                </Enllac>
                                <span>Temàtica: Periodisme</span>
                            </li>
                            <li>
                                <Enllac href='https://www.meseconomia.cat/' novaFinestra={true}>
                                    <span>Més economia</span>
                                </Enllac>
                                <span>Temàtica: Economia</span>
                            </li>
                            <li>
                                <Enllac href='http://www.mesebre.cat' novaFinestra={true}>
                                    <span>Més Ebre</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.mesosona.cat/' novaFinestra={true}>
                                    <span>Més Osona</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.metadata.cat/' novaFinestra={true}>
                                    <span>Metadata</span>
                                </Enllac>
                                <span>Temàtica: Tecnologia</span>
                            </li>
                            <li>
                                Món rural
                                <span>Temàtica: Agricultura</span>
                            </li>
                            <li>
                                <Enllac href='https://elmon.cat/monterrassa/' novaFinestra={true}>
                                    <span>Món Terrassa</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.montpeita.cat/' novaFinestra={true}>
                                    <span>Montpeità</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.noticiestgn.cat' novaFinestra={true}>
                                    <span>Notícies TGN</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.nuvol.com' novaFinestra={true}>
                                    <span>Núvol</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://onabages.cat/' novaFinestra={true}>
                                    <span>Ona Bages</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                Pànxing
                                <span>Temàtica: Societat</span>
                            </li>
                            <li>
                                <Enllac href='https://penedeseconomic.com/' novaFinestra={true}>
                                    <span>Penedés Econòmic</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://pensem.cat/' novaFinestra={true}>
                                    <span>Pensem</span>
                                </Enllac>
                                <span>Temàtica: Pensament polític i filosòfic</span>
                            </li>
                            <li>
                                <Enllac href='https://www.racocatala.cat/' novaFinestra={true}>
                                    <span>Racó Català</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.regio7.cat/' novaFinestra={true}>
                                    <span>Regió 7</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://reusdigital.cat' novaFinestra={true}>
                                    <span>Reus Digital</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.revistacambrils.cat' novaFinestra={true}>
                                    <span>Revista Cambrils</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://revistaderipollet.cat' novaFinestra={true}>
                                    <span>Revista de Ripollés</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://revistamirall.com/actualitat/' novaFinestra={true}>
                                    <span>Revista Mirall</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.rubitv.cat/' novaFinestra={true}>
                                    <span>Rubí TV</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://santboidiari.com' novaFinestra={true}>
                                    <span>Sant Boi diari</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.sapsque.com/badalona/' novaFinestra={true}>
                                    <span>Saps què?</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://www.segre.com' novaFinestra={true}>
                                    <span>Segre</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://sies.tv/' novaFinestra={true}>
                                    <span>SiesTV</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://www.facebook.com/sitgesactiu/' novaFinestra={true}>
                                    <span>Sitges actiu</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.social.cat' novaFinestra={true}>
                                    <span>Social Actiu</span>
                                </Enllac>
                                <span>Temàtica: Societat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.socpetit.cat' novaFinestra={true}>
                                    <span>Sóc Petit</span>
                                </Enllac>
                                <span>Temàtica: Família</span>
                            </li>
                            <li>
                                <Enllac href='https://somgranollers.cat' novaFinestra={true}>
                                    <span>Som Granollers</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://somlallagosta.cat' novaFinestra={true}>
                                    <span>Som la Llagosta</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://somlesfranqueses.cat' novaFinestra={true}>
                                    <span>Som les Franqueses</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://sommartorelles.cat' novaFinestra={true}>
                                    <span>Som Martorelles</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://sommollet.cat' novaFinestra={true}>
                                    <span>Som Mollet</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://sommontmelo.cat' novaFinestra={true}>
                                    <span>Som Montmeló</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://sommontornes.cat' novaFinestra={true}>
                                    <span>Som Parets</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://somsantfost.cat' novaFinestra={true}>
                                    <span>Som Sant Fost</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://somvalles.cat' novaFinestra={true}>
                                    <span>Som Vallès</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://surtdecasa.cat' novaFinestra={true}>
                                    <span>Surt de casa</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://diaridigital.tarragona21.com/' novaFinestra={true}>
                                    <span>Tarragona 21</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://tarragonadigital.com' novaFinestra={true}>
                                    <span>Tarragona digital</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tasta.cat/' novaFinestra={true}>
                                    <span>Tasta</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tdbactualitat.cat' novaFinestra={true}>
                                    <span>TDB Actualitat</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.teatral.net' novaFinestra={true}>
                                    <span>Teatral</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.territoris.cat/' novaFinestra={true}>
                                    <span>Territoris.cat</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.territoris.cat/blog/section/magazineterritoris' novaFinestra={true}>
                                    <span>Magazine territoris.cat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tornaveu.cat' novaFinestra={true}>
                                    <span>Tornaveu</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.totbarcelona.cat' novaFinestra={true}>
                                    <span>Tot Barcelona</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://totcerdanyola.cat' novaFinestra={true}>
                                    <span>Tot Cerdanyola</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://totesport.cat/' novaFinestra={true}>
                                    <span>Tot esport</span>
                                </Enllac>
                                <span>Temàtica: Esport</span>
                            </li>
                            <li>
                                <Enllac href='https://totgracia.com' novaFinestra={true}>
                                    <span>Tot Gràcia</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='http://www.totmataro.cat/' novaFinestra={true}>
                                    <span>Tot Mataró</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.totrubi.cat' novaFinestra={true}>
                                    <span>Tot Rubí</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.totsantcugat.cat/' novaFinestra={true}>
                                    <span>Tot Sant Cugat</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://elmon.cat/vadevi/' novaFinestra={true}>
                                    <span>Va de vi</span>
                                </Enllac>
                                <span>Temàtica: Vi</span>
                            </li>
                            <li>
                                <Enllac href='https://jomfriser.com/ventdelnord' novaFinestra={true}>
                                    <span>Ventdelnord TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://veuanoia.cat' novaFinestra={true}>
                                    <span>Veu Anoia</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.viaempresa.cat' novaFinestra={true}>
                                    <span>Via empresa</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.viasona.cat' novaFinestra={true}>
                                    <span>Viasona</span>
                                </Enllac>
                                <span>Temàtica: Musical</span>
                            </li>
                            <li>
                                <Enllac href='https://www.vilaweb.cat/categoria/vilawebtv/' novaFinestra={true}>
                                    <span>Vilaweb TV</span>
                                </Enllac>
                                <span>Temàtica: Altres</span>
                            </li>
                            <li>
                                <Enllac href='https://viuafons.cat' novaFinestra={true}>
                                    <span>Viu a fons</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.viumolinsderei.com' novaFinestra={true}>
                                    <span>Viu Molins de rei</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.viurealspirineus.cat' novaFinestra={true}>
                                    <span>Viure als Pirineus</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.xcatalunya.cat' novaFinestra={true}>
                                    <span>XCatalunya</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                Ycom
                                <span>Temàtica: Social mèdia</span>
                            </li>
                            <li>
                                <Enllac href='http://zona-sec.cat' novaFinestra={true}>
                                    <span>Zona Sec</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            {/*<!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  CATALUNYA NORD     -->*/}
            <div id='catalunyaNord' className={styles.zona}>
                <div className={styles.zonaHeading}>
                    <h3>Catalunya Nord</h3>
                    <span className={styles.inici}>
                        <Enllac href='#mitjans'>
                            <span>tornar a dalt</span>
                        </Enllac>
                        <Icona className={styles.icona} icona='fletxa_simple_amunt' alt='anar amunt' isBlanc={false} mida={30} />
                    </span>
                </div>
                <ul>
                    <li>
                        <h4>Televisió</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac
                                    href='https://france3-regions.francetvinfo.fr/occitanie/emissions/jt-local-1920-pais-catala'
                                    novaFinestra={true}
                                >
                                    <span>France 3 FR</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Ràdio</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='http://www.radioarrels.cat/' novaFinestra={true}>
                                    <span>Ràdio Arrels</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Mitjans digitals Audiovisuals</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://www.elpuntavui.cat/comarca/catalunya-nord.html' novaFinestra={true}>
                                    <span>El Punt Avuí Catalunya Nord</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.vilaweb.cat/categoria/pais/catalunya-nord/' novaFinestra={true}>
                                    <span>Catalunya Nord Vilaweb</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.la-clau.net/' novaFinestra={true}>
                                    <span>La clau</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            {/*<!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~   PAIS VALENCIA   -->*/}

            <div id='paisValencia' className={styles.zona}>
                <div className={styles.zonaHeading}>
                    <h3>País Valencià</h3>
                    <span className={styles.inici}>
                        <Enllac href='#mitjans'>
                            <span>tornar a dalt</span>
                        </Enllac>
                        <Icona className={styles.icona} icona='fletxa_simple_amunt' alt='anar amunt' isBlanc={false} mida={30} />
                    </span>
                </div>
                <ul>
                    <li>
                        <h4>Televisió</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://apuntmedia.es/va/' novaFinestra={true}>
                                    <span>Àpunt Televisió</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://canal56.com/' novaFinestra={true}>
                                    <span>Canal 56 Televisió Comarcal</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://comarcal.tv/' novaFinestra={true}>
                                    <span>Comarcal TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.intercomarcal.com/?idioma=1' novaFinestra={true}>
                                    <span>Intercomarcal Televisión</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.laocho.tv/' novaFinestra={true}>
                                    <span>La 8 Mediterráneo</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.levante-emv.com/videos/levante-tv/' novaFinestra={true}>
                                    <span>Levante TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.elperiodicvalencia.com/' novaFinestra={true}>
                                    <span>Ribera TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://telepobla.tv' novaFinestra={true}>
                                    <span>Telepobla</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://7televalencia.com/es/' novaFinestra={true}>
                                    <span>7TeleValencia</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://suecatv.com/' novaFinestra={true}>
                                    <span>Sueca TV</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://telesafor.com/' novaFinestra={true}>
                                    <span>TeleSafor</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tv-a.es/' novaFinestra={true}>
                                    <span>TV-A</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tvcs.tv/' novaFinestra={true}>
                                    <span>TVCS</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://teve4.com/' novaFinestra={true}>
                                    <span>TeVe4</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.laocho.tv/' novaFinestra={true}>
                                    <span>TV Mediterráneo</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Ràdio</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://apuntmedia.es/va/directe/radio' novaFinestra={true}>
                                    <span>Àpunt Ràdio</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://comarquesnord.cat/mitjans/els-ports-radio/' novaFinestra={true}>
                                    <span>Els Ports Ràdio</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.radio.es/s/alzira' novaFinestra={true}>
                                    <span>Alzira Ràdio</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.radiopego.com/' novaFinestra={true}>
                                    <span>Ràdio Pego</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.radiococentaina.com' novaFinestra={true}>
                                    <span>Ràdio Cocentaina</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://laveu.ondara.org/' novaFinestra={true}>
                                    <span>La veu d&apos;Ondara</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.radioaltea.com/' novaFinestra={true}>
                                    <span>Ràdio Altea</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://xemv.fvmp.es/es/emisoras/radio-rabosa-almassera/' novaFinestra={true}>
                                    <span>Ràdio Rabosa</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://radiolom.es' novaFinestra={true}>
                                    <span>Ràdio l&apos;Om</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.noveldaradio.es/' novaFinestra={true}>
                                    <span>Novelda Ràdio</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='http://www.radiovila-real.es' novaFinestra={true}>
                                    <span>Ràdio Vila-real</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='http://llosafm.net' novaFinestra={true}>
                                    <span>Llosa FM</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.radiobenicarlo.org' novaFinestra={true}>
                                    <span>Ràdio Benicarló</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.radiogodella.com' novaFinestra={true}>
                                    <span>Ràdio Godella</span>
                                </Enllac>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>Mitjans digitals Audiovisuals</h4>
                        <ul className={styles.llistat}>
                            <li>
                                <Enllac href='https://comarquesnord.cat/' novaFinestra={true}>
                                    <span>Comarques Nord</span>
                                </Enllac>
                                <span>Temàtica: Actualitat</span>
                            </li>
                            <li>
                                <Enllac href='https://www.nosaltreslaveu.com' novaFinestra={true}>
                                    <span>Nosaltres La Veu</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://infomaestrat.com/' novaFinestra={true}>
                                    <span>Info Maestrat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                El diari online
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://diaridelmaestrat.com' novaFinestra={true}>
                                    <span>Diari del Maestrat</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.aramultimedia.com' novaFinestra={true}>
                                    <span>Ara Multimèdia</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='http://www.diaridebenicassim.com' novaFinestra={true}>
                                    <span>Diari de Benicàssim</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.infobenissa.com/' novaFinestra={true}>
                                    <span>Info Benissa</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.blanquinegres.com/' novaFinestra={true}>
                                    <span>Blanquinegres</span>
                                </Enllac>
                                <span>Temàtica: Esports</span>
                            </li>
                            <li>
                                <Enllac href='https://www.betera.com' novaFinestra={true}>
                                    <span>Bétera.com</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://diariserpis.com' novaFinestra={true}>
                                    <span>Diari del Serpis</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://actualitatvalenciana.com' novaFinestra={true}>
                                    <span>Actualitat Valenciana</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.infoturia.com' novaFinestra={true}>
                                    <span>InfoTúria</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://diarimillars.es' novaFinestra={true}>
                                    <span>Diari Millars</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://www.tresdeu.com' novaFinestra={true}>
                                    <span>Tresdeu</span>
                                </Enllac>
                                <span>Temàtica: Música</span>
                            </li>
                            <li>
                                <Enllac href='https://www.lesmuntanyes.com' novaFinestra={true}>
                                    <span>Les muntanyes</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://tvdigitalontinyent.com' novaFinestra={true}>
                                    <span>TVDigital Ontinyent</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://revistasao.cat' novaFinestra={true}>
                                    <span>Revista Saó</span>
                                </Enllac>
                                <span>Temàtica: Cultura</span>
                            </li>
                            <li>
                                <Enllac href='https://lamarinaplaza.com/ca/' novaFinestra={true}>
                                    <span>La Marina Plaza</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://valenciaplaza.com' novaFinestra={true}>
                                    <span>Valencia Plaza</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://alicanteplaza.es' novaFinestra={true}>
                                    <span>Alicante Plaza</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                            <li>
                                <Enllac href='https://castellonplaza.com' novaFinestra={true}>
                                    <span>Castellón Plaza</span>
                                </Enllac>
                                <span>Temàtica: Generalista</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}
